// Regex Matchers
export const CONTAINS_SPECIAL_CHARACTER = /[^A-Za-z0-9]/;
export const CONTAINS_UPPERCASE = /[A-Z]/;
export const CONTAINS_LOWERCASE = /[a-z]/;
export const CONTAINS_DIGIT = /[\d]/;

export const PASSWORD_MIN_LENGTH = 6;
